import {Log} from '@aboutyou/mlm';
import {doAsync, getCookieValue, setCookie} from '@aboutyou/utils';
import {EXPIRY_6_MONTHS_IN_DAYS} from '../user-state/userStore/constants';

export const getUserDataFromCookies = <T>({
  storageKey,
  cookieDomain,
}: {
  storageKey: string;
  cookieDomain?: string;
}): T | null => {
  try {
    const encodedCookie = getCookieValue(storageKey);
    if (!encodedCookie) {
      return null;
    }
    const decodedCookie = decodeURIComponent(encodedCookie);
    const parsed = JSON.parse(decodedCookie);

    /**
     * We need to extend the cookie by another 6 months every time the user comes to the page.
     * This is in line with the Checkout Auth Expiry logic.
     */
    doAsync(() => {
      setUserDataToCookies({
        storageKey,
        data: parsed,
        cookieDomain,
      });
    });

    return parsed;
  } catch (error) {
    Log.error('@aboutyou/user', 'Failed reading user data from cookies', {
      error,
    });
    return null;
  }
};

export const setUserDataToCookies = ({
  storageKey,
  cookieDomain,
  data,
}: {
  storageKey: string;
  cookieDomain?: string;
  data: {};
}) => {
  try {
    const encodedData = encodeURIComponent(JSON.stringify(data));

    setCookie({
      name: storageKey,
      value: encodedData,
      domain: cookieDomain,
      expirationInDays: EXPIRY_6_MONTHS_IN_DAYS,
    });
  } catch (error) {
    Log.error('@aboutyou/user', 'Failed setting user data to cookies', {
      error,
    });
  }
};
